<template>
  <modal name="addonsModal" class="event-modal faq-modal" :width="'900px'" :height="'auto'" :scrollable="true">
    <div class="modal-header">
      <div class="modal-header-text">
        <span>ADD ONS AND POLICIES</span>
      </div>
      <!--<div class="modal-close-button" @click="hideModal()">X</div>-->
      <div class="modal-close-img" @click="hideModal()" @mouseover="isHoverClose = true"
           @mouseleave="isHoverClose = false">
        <img src="../../../static/img/info-modal-close.svg" alt="close" v-if="!isHoverClose">
        <img src="../../../static/img/info-modal-close-hover.svg" alt="close" v-if="isHoverClose">
      </div>
      <!-- <div class="line"></div> -->
    </div>
    <div class="modal-body">
      <div class="faq-section">
        <span class="modal-body-title">What are Add Ons?</span><br/>
        <span class="modal-body-text">These are custom additions that are not included in our Standard Events. Please refer to your contract for billing details, as minimums and additional fees may apply.</span>
      </div>
      <div class="faq-section">
        <span class="modal-body-title">Descriptions</span><br/>
        <span class="modal-body-sub-title">Venipuncture</span><br/>
        <span class="modal-body-text">By request ADURO will partner with a 3rd party vendor to provide onsite events utilizing the venipuncture method to collect the blood sample. The samples will be transported to an off-site laboratory for processing and results will be sent to ADURO to be uploaded into the platform. Participants will NOT receive a hard copy of their test results from the blood draw. Participants will receive a scorecard with their body composition results.</span><br/><br/>
        <span class="modal-body-sub-title">Cotinine</span><br/>
        <span class="modal-body-text">The iScreen OFD is an oral fluid screening test that can be included at an onsite event to screen for tobacco use. The staff will administer this test an obtain results within 10 minutes. The iScreen device detects up to 1- 2 days after nicotine use. These results will be entered the ConnectWell technology during the onsite event and transferred into the platform.</span><br/><br/>
        <span class="modal-body-sub-title">Well Being Assessment (WBA) Station</span><br/>
        <span class="modal-body-text">By request, ADURO can provide the optional WBA station occurs after the Program Concierge station. This prevents delays in screening event flow and helps maintain the 15-minute appointment timeline. The WBA is accessed inside of each participant’s platform account; therefore, the participants must be able to log into their account without assistance during the onsite event. It can take up to 20 minutes for a participant to complete the WBA.  For events with WBA stations, ADURO provides and set up a station with tablets. The station itself is unmanned and ADURO is unable to provide technical support.</span><br/><br/>
        <span class="modal-body-sub-title">Flu Shots</span><br/>
        <span class="modal-body-text">By request ADURO will partner with a 3rd party vendor to provide flu shots at an additional station</span><br/><br/>
        <span class="modal-body-sub-title">Paper Scheduler</span><br/>
        <span class="modal-body-text">The ADURO Event Manager will provide a “paper” appointment scheduler template for participants to sign up for a screening. The template will be created based on the number of expected participants and duration of event. each appointment is 15 minutes in length. The template cannot be altered without the approval of the Event Manager. It is the responsibility of the client to provide the completed schedule of appointments to the Event Lead on the day of event.  ADURO will be unable to provide appointment confirmations, reminders or participation reports when paper schedulers are used. An event cannot include a combination of paper and online registrations. Customers can either have a paper or online registration process per event.</span><br/><br/>
        <span class="modal-body-sub-title">Small Site Model</span><br/>
        <span class="modal-body-text">Onsite biometric screening events where ADURO will perform the following tests using the Finger Stick method; Total cholesterol, HDL, LDL, triglycerides and glucose and the following physical tests: blood pressure, heart rate and BMI (or equivalent body composition test).  The participant will leave with an unidentified scorecard with all their values. This service includes access to the online appointment scheduler, dedicated Event Manager and same day results transfer into the platform utilizing our ConnectWell technology.  For Small Site, one person (an Event Lead) is sent to the event to screen all participants, so the projected participation is limited to what one person can accomplish within 8 hours or less.  One person can screen 4 people per hour, with a max of 32 participants in 8 hours.  Any event can be Small Site as long as it meets these criteria.</span><br/><br/>
        <span class="modal-body-sub-title">Small Site Concierge</span><br/>
        <span class="modal-body-text">Program Concierge is not an included service with the Small Site model but can be purchased as a buy-up option, in which case we would send an additional person to run the Concierge station (two people total).</span>
      </div>
    </div>
  </modal>
</template>
<script>
  export default {
    name: '',
    components: {},
    data () {
      return {
        isHoverClose: false
      }
    },
    methods: {
      hideModal () {
        this.$modal.hide('addonsModal');
      }
    },
    computed: {}
  }
</script>

<style lang="less" scoped="">
  @import '../../styles/variables.less';

  .faq-modal {
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .event-modal {
    margin: 0;
    background: rgba(0, 0, 0, 0.4);

    .modal-close-button {
      float: right;
      font-size: 20px;
      &:hover {
        cursor: pointer;
      }
    }

    .modal-header {
      border: 0;
      width: 100%;
      padding: 0 65px;
      margin: 0 auto;

      .line {
        box-sizing: border-box;
        height: 3px;
        width: 593px;
        border: 1px solid #E6E6E6;
      }
      .modal-header-text {
        margin-top: 50px;
        height: 40px;
        color: #231f20;
        font-family: Arquitecta, sans-serif;
        font-size: 24px;
        font-weight: bold;
        line-height: 30px;
        text-transform: uppercase;
        border-bottom: 1px solid #c2cfd6;
        width: 80%;
      }
      .modal-header-change-order-text {
        margin-top: 25px;
        margin-left: 25px;
        height: 29px;
        width: auto;
        color: @black;
        font-family: @font-family-title;
        font-size: 24px;
        font-weight: bold;
        line-height: 29px;
        text-transform: uppercase;
      }
      .modal-header-line {
        box-sizing: border-box;
        height: 3px;
        width: 593px;
        border: 1px solid @grey-4;
      }
      .modal-close-img {
        position: absolute;
        right: 17px;
        top: 17px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .modal-body {
      height: auto;
      width: 100%;
      margin: 0 auto;
      padding: 0 65px 25px 65px;
      .faq-section {
        padding: 20px 0;
        border-bottom: solid 1px @grey-4;
        &:last-child {
          border-bottom: none;
        }
        .modal-body-title {
          font-family: @font-family-main;
          font-size: 18px;
          font-weight: bold;
          line-height: 50px;
        }
        .modal-body-sub-title {
          font-weight: 600;
        }
        .modal-body-text {
          color: @black;
          font-family: @font-family-main;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AddonsModal.vue?14c4bb33